import React, { useReducer, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../redux/rootReducers';
import {
  SELECT_FOLDER,
  UPDATE_FOLDER,
  SET_CHILD_FOLDERS,
  SET_CHILD_FILES,
  initialStateType,
  useFolderType,
  folderType
} from './useFolderTypes';
import { getChildFoldersAction } from '../../redux/fileManager';
import { GetChildFoldersTypePayload } from '../../commonTypes/fileManagerTypes';
import { useLocation } from 'react-router-dom';

const initialState: initialStateType = {
  folderId: null,
  folder: {} as folderType,
  childFolders: [],
  childFiles: []
}

export const ROOT_FOLDER: folderType = { name: "Home", id: 0, full_path: "[]" }

function reducer(state = initialState, { type, payload }: any): initialStateType {
  switch (type) {
    case SELECT_FOLDER:
      return {
        folderId: payload.folderId,
        folder: payload.folder,
        childFolders: [],
        childFiles: [],
      }
    case UPDATE_FOLDER:
      return {
        ...state,
        folder: payload.folder
      }
    case SET_CHILD_FOLDERS:
      return {
        ...state,
        childFolders: payload.subFolders
      }
    case SET_CHILD_FILES:
      return {
        ...state,
        childFiles: payload.subFiles
      }
    default:
      return state;
  }
}

export const useFolder = (
  folderId: string | null = null,
  folder: folderType | null = null,
  client_code: number
) => {
  const dispatchAction = useDispatch();
  const token = useSelector((state: RootState) => state.auth.token);
  const subFolders = useSelector((state: RootState) => state.fileManager.childFolders);
  const subFiles = useSelector((state: RootState) => state.fileManager.childFiles);
  const {pathname} = useLocation();
  // Reducer function call
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    dispatch({ type: SELECT_FOLDER, payload: { folderId, folder } })
  }, [folderId, folder]);

  useEffect(() => {
    if (folderId == '0') {
      return dispatch({ type: UPDATE_FOLDER, payload: { folder: ROOT_FOLDER } })
    } else {
      return dispatch({ type: UPDATE_FOLDER, payload: { folder: folder } })
    }
  }, [folderId]);

  // Fetching Child Folders
  useEffect(() => {
    if (client_code && folderId) {
      let finalData = {
        token,
        client_code,
        folder_id: folderId
      }

      dispatchAction(getChildFoldersAction(finalData))
    }
  }, [folderId, client_code]);

  // Setting Child Folders
  useEffect(() => {
    dispatch({
      type: SET_CHILD_FOLDERS,
      payload: { subFolders }
    });

    if ((folder === null || folder === undefined) && folderId != '0') {
      dispatch({
        type: UPDATE_FOLDER,
        payload: { folder: subFolders?.length ? subFolders?.[0] : null }
      })
    }
  }, [subFolders]);

  // Setting Child Files
  useEffect(() => {
    dispatch({
      type: SET_CHILD_FILES,
      payload: { subFiles }
    })
  }, [subFiles])

  return state;
};

